<template>
  <div class="sms-blast">
    <div class="sms-blast__wrapper">
      <div class="sms-blast__wrapper__header">
        <div class="sms-blast__wrapper__header__title">
          <h1 class="medium-title">
            Campaign Editor
          </h1>
        </div>
        <div class="sms-blast__wrapper__header__subtitle">
          <span>
            Set your sms blast campaign details
          </span>
        </div>
        <div class="sms-blast__wrapper__header__breadcrumb">
          <adx-breadcrumb :items="breadcrumb" />
        </div>
      </div>
      
      <div class="sms-blast__wrapper__content">
        <div v-if="step == 1" class="sms-blast__wrapper__content__iklan">
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__field">
              <adx-input :label="`Campaign Name *`" :value.sync="name" :ref="dataRef1.name" :error.sync="nameError" :validation="['NotEmpty', 'MaxLength:50']"/>
            </div>
          </div>
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__field id">
              <adx-input disabled :label="`ID Pengirim`" :value.sync="idPengirim" />
            </div>
          </div>
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__header">
              <span class="title">Schedules</span>
            </div>
            <div class="sms-blast__wrapper__content__wrapper__fields">
              <div class="calendar">
                <v-date-picker
                  v-model='startCampaign'
                  :min-date='nextweek'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      :value='inputValue'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      <label class="subhead calendar-label">Start Date</label>
                  </div>
                </v-date-picker>
              </div>
              <div class="calendar">
                <v-date-picker
                  v-model='endCampaign'
                  :min-date='startCampaign > nextweek ? startCampaign : nextweek'
                  :popoverVisibility="'focus'"
                  :theme-styles='themeStyles'
                  class='date-picker'>
                  <div class="field"
                    slot-scope='{ inputValue, updateValue }'
                  >
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      :value='inputValue'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      <label class="subhead calendar-label">End Date</label>
                  </div>
                </v-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="step == 2" class="sms-blast__wrapper__content__target">
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__header">
              <span class="title">SMS receiver phone number</span>
            </div>
            <div class="sms-blast__wrapper__content__wrapper__field">
              <!-- <adx-textarea :label="`E.g. 0811890928, 0812290229`" :value.sync="phoneNumbers"/> -->
              <adx-input-tag
                :limit='limit'
                v-model='phoneNumbers'
                :ref="dataRef.phoneNumbers"
                :error.sync="phoneNumbersError"
                :placeholder='placeholder'
                :read-only='readOnly'
                :validate='validate'
                :add-tag-on-blur='addTagOnBlur'
              />
            </div>
            <div class="sms-blast__wrapper__content__wrapper__field">
              <div class="div-wrapper">
                <div class="left">
                  <label>Or you can upload file instead ( .csv, .xls, xlsx )</label><br />
                  <label>{{phoneNumbersFileName}}</label>
                </div>
                <div class="right">
                  <input type="file" accept=".csv, .xls, .xlsx" @change="getFile"
                  ref="fileUpload" style="display: none;">
                  <button
                    type="button"
                    :class="['secondary', 'btn-small', 'btn-checkout-large', isSaving ? 'disabled' : '']"
                    @click="launchFilePicker">
                    Upload File
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__header">
              <span class="title">Message</span>
            </div>
            <div class="sms-blast__wrapper__content__wrapper__field">
              <adx-textarea :ref="dataRef.message" :error.sync="messageError" :label="`Your message max 160 characters *`" :validation="['NotEmpty', 'MinLength:2', 'MaxLength:160']" :value.sync="message"/>
            </div>
          </div>
        </div>
        <div v-if="step == 3" class="sms-blast__wrapper__content__budget">
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__header">
              <span class="title">SMS blast packages</span>
            </div>
            <!-- <li v-if="item.title" v-for="(item, index) in items" :key="index" :class="['small-title', item.isCurrent ? 'current' : '']">{{item.title | capitalizing}}</li> -->
            <div class="sms-blast__wrapper__content__wrapper__fields__radio">
              <div v-for="(item, index) in smsPackageOptions" :key="index" class="radio-group">
                <div class="radio">
                  <input type="radio" :id="item.id" :value="item.id" v-model="smsPackage"/>
                  <label class="subhead" :for="item.id">{{item.price | formatMoney}}</label>
                </div>
                <p class="description">
                  {{item.quantity}} SMS Blast<br />
                  All national number
                </p>
              </div>
            </div>
          </div>
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__header">
              <span class="strong subhead">Promo Code</span>
            </div>
            <div v-if="!isPromoCodeValid" class="sms-blast__wrapper__content__wrapper__fields">
              <adx-input :button="`Use`" :label="`Input Promo Code`" :error.sync="promoCodeError" :value.sync="promoCode" @buttonClicked="useVoucher" :upperCase="true"/>
            </div>
            <div v-else class="sms-blast__wrapper__content__wrapper__fields">
              <div if class="sms-blast__wrapper__content__wrapper__fields__dialog">
                <div class="sms-blast__wrapper__content__wrapper__fields__dialog__button">
                  <i class="adx-ic_close" @click="unuseVoucher"></i>
                </div>
                <div class="sms-blast__wrapper__content__wrapper__fields__dialog__header">
                  <span>Kode Promo: </span>
                  <span class="code">{{promoCode}}</span>
                </div>
                <div class="sms-blast__wrapper__content__wrapper__fields__dialog__description">
                  <span>
                    Congrats! you get discount - {{discount | formatMoney}} for this transaction
                  </span>
                </div>
              </div>
              <span v-if="promoCodeError" class="sms-blast__wrapper__content__wrapper__error"> {{promoCodeError}} </span>
            </div>
            <div class="payment__clear-both"></div>
          </div> 
          <div v-if="promoNominal" class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__header">
              <span class="strong subhead">Total Price : {{ discountedPrice | formatMoney }}</span>
            </div>
            <p>*This is price you need to pay after discount</p>
          </div>
          <div class="sms-blast__wrapper__content__wrapper">
            <div class="sms-blast__wrapper__content__wrapper__header">
              <span class="title">Additional Notes and Comments</span>
            </div>
            <div class="sms-blast__wrapper__content__wrapper__field">
              <adx-textarea :label="`Your message max 200 characters`" :value.sync="notes" :validation="['MaxLength:200']"/>
            </div>
          </div>
        </div>
      </div>
      <div class="sms-blast__wrapper__button">
        <button
          v-if="step > 1"
          type="button"
          class="btn-large secondary"
          :disabled="isSaving"
          @click="previous">
          Previous
        </button>
        <button
          v-if="step < 3"
          type="button"
          class="btn-large primary"
          :disabled="isSaving"
          @click="next">
          Continue
        </button>
        <button
          v-if="step == 3"
          type="button"
          class="btn-large primary"
          :disabled="isSaving"
          @click="sendEmail">
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Input from '@/components/Form/Input'
import InputTag from '@/components/Form/InputTag'
import Radio from '@/components/Form/Radio'
import TextArea from '@/components/Form/TextArea'
import Dropdown from '@/components/Form/SelectDropdown'
import moment from 'moment';

import api from '@/api'
import { apiV2 } from '@/api/urls'
import obj2fd from 'obj2fd'

export default {
  name: 'adx-sms-blast',
  components: {
    'adx-breadcrumb': Breadcrumb,
    'adx-input': Input,
    'adx-radio': Radio,
    'adx-textarea': TextArea,
    'adx-dropdown': Dropdown,
    'adx-input-tag': InputTag
  },
  props: {

  },
  data() {
    return {
      readOnly: false,
      addTagOnBlur: false,
      allowDuplicates: false,
      placeholder: "Separate phone numbers with a comma",
      tags: [],
      limit: 100,
      validate: "",
      step: 1,
      today: moment(),
      dataRef: {
        phoneNumbers: 'phoneNumbers',
        message: 'message'
      },
      dataRef1: {
        name: 'name'
      },
      name: '',
      nameError: '',
      idPengirim: '',
      idPengirimError: '',
      startCampaign: '',
      startCampaignError: '',
      endCampaign: '',
      endCampaignError: '',
      phoneNumbers: [],
      phoneNumbersError: '',
      phoneNumbersFile: null,
      phoneNumbersFileName: '',
      phoneNumbersFileData: null,
      notes: '',
      message: '',
      messageError: '',
      smsPackage: null,
      isSaving: false,
      promoCode: '',
      discount: 0,
      promoNominal: 0,
      isPromoCodeValid: false,
      promoCodeError: '',
      locationOptions: [
        {
          label: 'Rp 250.000',
          value: '250000',
        },
        {
          label: 'Rp 500.000',
          value: '500000',
        },
        {
          label: 'Rp 750.000',
          value: '750000',
        },
        {
          label: 'Rp 1.000.000',
          value: '1000000',
        }
      ],
      keywordOptions: [
        {
          label: 'Let us give best keyword for you',
          value: '0',
        },
        {
          label: 'Create keyword manually',
          value: '1',
        }
      ],
      scheduleOptions: [
        {
          id: 0,
          label: `1 week`,
          value: `1w`
        },
        {
          id: 1,
          label: `2 week`,
          value: `2w`
        },
        {
          id: 2,
          label: `1 month`,
          value: `1m`
        },
        {
          id: 3,
          label: `2 month`,
          value: `2m`
        },
        {
          id: 4,
          label: `3 month`,
          value: `3m`
        },
      ],
      genderOptions: [
        {
          id: 0,
          label: `male`,
          value: `m`
        },
        {
          id: 1,
          label: `female`,
          value: `f`
        }
      ],
      ageOptions: [
        {
          id: 0,
          label: `20`,
          value: 20
        },
        {
          id: 1,
          label: `30`,
          value: 30
        }],
      breadcrumb: [
        {
          title: '1. Iklan',
          isCurrent: true
        },
        {
          title: '2. Target',
          isCurrent: false
        },
        {
          title: '3. Budget',
          isCurrent: false
        }
      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      smsPackageOptions: []
    }
  },
  computed: {
    nextweek() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      return nextweek
    },
    discountedPrice() {
      var budget = this.smsPackageOptions.filter(value => { return value.id == this.smsPackage})[0]
      var price = parseInt(budget.price) - this.promoNominal
      if (price < 0) return 0
      return price
    }
  },
  watch: {
    phoneNumbersFileName: function () {
      this.$nextTick(() => {
        this.phoneNumbersValidation()
      });
    },
    promoCode: function () {
      this.promoCode = this.promoCode.toUpperCase()
    },
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.getSMSPackage()
    this.setValue()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    useVoucher() {
      (async () => {
        this.promoCodeError = ''
        this.discount -= this.promoNominal
        let params = {
          voucher_code: this.promoCode
        }
        const response = await api.get(apiV2.checkVoucher, { needToken: true, params: params })
        if (response.status == 200) {
          this.promoNominal = response.data.nominal
          this.discount += response.data.nominal
          let budget = this.smsPackageOptions.filter(value => { return value.id == this.smsPackage})[0]
          // if (parseInt(budget.price) <= this.promoNominal) {
          //   this.promoNominal = parseInt(parseInt(budget.price))
          //   this.discount = parseInt(parseInt(budget.price))
          // } 
          // else if (this.totalPrice < 9999 ) {
          //   this.promoCodeError = 'Total price should not be be between Rp 0 and Rp 10.000'
          //   this.loadingMidTrans = true
          // } 
          this.isPromoCodeValid = true
        } else {
          this.isPromoCodeValid = false
          this.promoCodeError = response.data.message
        }
      })();
    },
    unuseVoucher() {
      this.isPromoCodeValid = false
      this.discount -= this.promoNominal
      this.promoNominal = 0
    },
    setValue() {
      var nextweek = new Date();
      nextweek.setDate(nextweek.getDate() + 7);
      this.startCampaign = nextweek
      var nextweekplus = new Date();
      nextweekplus.setDate(nextweekplus.getDate() + 8);
      this.idPengirim = "Smart UKM"
      this.endCampaign = nextweekplus
      this.breadcrumb[this.step-1].isCurrent = false
      this.breadcrumb[0].isCurrent = true
      this.step = 1
    },
    previous() {
      this.breadcrumb[this.step-1].isCurrent = false
      this.breadcrumb[this.step-2].isCurrent = true
      this.step = this.step == 2 ? 1 : 2
    },
    next() {
      let validation = this.validateForm()
      if (validation.isValid) {
        this.breadcrumb[this.step-1].isCurrent = false
        this.breadcrumb[this.step].isCurrent = true
        this.step = this.step == 1 ? 2 : 3
      } else {
        this.raiseError(validation.id)
      }
    },
    sendEmail() {
      (async () => {
        this.isSaving = true
        let validation = this.validateForm()
        if (validation.isValid) {
          let body = null
          if (this.phoneNumbersFile) {
            body = {
              blast: {
                campaign_name: this.name,
                receivers: 'Smart UKM',
                receiver_file: null,
                notes: this.notes,
              },
              detail: {
                sender: this.idPengirim,
                start_date: this.startCampaign,
                end_date: this.endCampaign,
                message: this.message
              },
              package: this.smsPackage,
              promo: {
                code: this.promoCode,
                nominal: this.promoNominal
              }
            }
            
          } else {
            body = {
              blast: {
                receivers: this.phoneNumbers.join(),
                notes: this.notes,
                campaign_name: this.name,
              },
              detail: {
                sender: this.idPengirim,
                start_date: this.startCampaign,
                end_date: this.endCampaign,
                message: this.message
              },
              package: this.smsPackage,
              promo: {
                code: this.promoCode,
                nominal: this.promoNominal
              }
            }
          }
          const response = await api.post(apiV2.smsBlast, body, {needToken: true})

          const file = {
            receiver_file: this.phoneNumbersFileData
          }

          let image = new FormData();

          image = obj2fd(file)

          if(this.phoneNumbersFileData){
            const response1 = await api.patch(apiV2.smsBlastFile(response.data.id), image, {needToken: true})
          }
          if (response.status === 201) {
            this.$notify({
              group: 'saved',
              title: 'Success',
              text: `Data successfully saved!`,
              type: 'success'
            });
            this.$router.push({name: 'transactiondigitaladvertising'})
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: response.statusText,
              type: 'danger'
            });
          }
        } else {
          this.raiseError(validation.id)
        }
        this.isSaving = false
      })();
    },
    getSMSPackage() {
      try {
        (async () => {
          const params = {
            type: 'bl'
          }
          const data = await api.get(apiV2.smsPackage, { params, needToken: true })
          let items = data.data
          for (var i=0; i < items.length; i++){
            this.smsPackageOptions.push(
              {
                id: items[i].id,
                price: items[i].price,
                quantity: items[i].quantity
              }
            )
          }
          this.smsPackage = this.smsPackageOptions[0].id
        })();
      } catch (err) { 
      }
    },
    getFile(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.phoneNumbersFile = e.target.result
        }
        reader.readAsDataURL(input.files[0]);
        this.phoneNumbersFileName = input.files[0].name
        this.phoneNumbersFileData = input.files[0]
      }
    },
    launchFilePicker(){
      this.$refs.fileUpload.click();
    },
    phoneNumbersValidation() {
      if (this.phoneNumbersFileName != "") {
        this.phoneNumbersError = ""
      } else {
        if (this.phoneNumbers == "") {
          this.phoneNumbersError = "You can’t leave this empty"
        } else {
          this.phoneNumbersError = ""
        }
      }
    },
    validateForm() {
      let data = { isValid: true, id: null }
      let dataRef = null
      if (this.step == 1) {
        dataRef = this.dataRef1
      } else if (this.step == 2) {
        dataRef = this.dataRef
      }

      for (let key in dataRef) {
        const value = this.$data[key]
        if (!value || this.inputInvalid(dataRef[key])) {
          data.isValid = false
          if (this.step == 1) {
            data.id = dataRef[key]
          } else if (this.step == 2) {
            data.id = dataRef[key]
          }
          break
        }
      }

      return data
    },
    raiseError(id) {
      let element = this.$refs[id].$el.firstElementChild
      element.focus()
      element.blur()
    },
    inputInvalid(value) {
      let error = false
      let dataRef = null
      if (this.step == 1) {
        dataRef = this.dataRef1
      } else if (this.step == 2) {
        dataRef = this.dataRef
      }

      switch(value) {
        case dataRef.name:
          error = this.nameError
          break
        case dataRef.phoneNumbers:
          this.phoneNumbersValidation()
          error =  this.phoneNumbersError
          break
        case dataRef.message:
          error = this.messageError
          break
      }
      return error
    },
    reset() {
      this.idPengirim  = ''
      this.startCampaign  = ''
      this.endCampaign  = ''
      this.phoneNumbers  = []
      this.message  = ''
      this.smsPackage = this.smsPackageOptions[0].id
      this.setValue()
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
  .selectDropdown {

    .select {
      .standardInput {
        padding: 16px !important;
      }
    }
  }
  .small-title {
    font-size: 15px;
    font-weight: normal !important;

    &.current {
      font-weight: bold !important;
    }
  }
  .id {
    .input{
      input {
        color: #999999 !important;
      }
    }
  }
</style>